export default __webpack_public_path__ + "static/media/2 S-6071PF3E.9155bc7a.jpg";